import { m as motion } from "motion/react";
import { useAnimateFadeIn } from "../../../animation/animation";
import Heading from "../../elements/heading/heading";
import styles from "./text-block.module.less";

type TTextBlockProps = {
  title?: string;
  preamble?: string;
  text?: React.ReactNode;
};

export const TextBlock = ({ title, preamble, text }: TTextBlockProps) => {
  const fadeInAnimation = useAnimateFadeIn({ whileInView: true, easing: "easeInOut" });

  return (
    <section className={styles.section}>
      <motion.div {...fadeInAnimation} className={"max-width padded-sides centered"}>
        <Heading semanticType={"h2"} visualType={"h3"} className={"heading-max-width"}>
          {title}
        </Heading>
        {preamble && <p className={`${styles.preamble} preamble text-max-width`}>{preamble}</p>}
        <div className={"text-max-width"}>{text}</div>
      </motion.div>
    </section>
  );
};

export default TextBlock;
